import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';

import { required } from '../../../../common/services/ValidationRules';
import Button from '../../../../common/components/Button/Button';
import { renderTextField } from '../../../ChargerDetails/components/ChargerDetailsFormRenderers/renderTextField';

import './_styles.scss';

const nameFiled = {
  name: 'name',
  validate: [required],
  floatingLabelText: 'Name',
  starred: true,
};

function RoleFormComponent({ reset, onCancel, onFormChange, isSubmitting, isPristine, invalid, handleSubmit }) {
  const handleCancel = () => {
    reset();
    onCancel();
  };

  const handleFormChange = (e) => {
    onFormChange(e.target.name, e.target.value);
  };

  return (
    <form className="role-form" onSubmit={handleSubmit} onChange={handleFormChange}>
      <div>{renderTextField(nameFiled)}</div>
      <div className="role-form-footer">
        <Button disabled={isSubmitting || isPristine} className="role-form-button" variant="contained" onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          disabled={invalid || isSubmitting || isPristine}
          className="role-form-button"
          type="submit"
          color="primary"
          variant="contained"
        >
          Submit
        </Button>
      </div>
    </form>
  );
}

RoleFormComponent.propTypes = {
  isSubmitting: PropTypes.bool,
  invalid: PropTypes.bool,
  isPristine: PropTypes.bool,
  handleSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  onFormChange: PropTypes.func,
  reset: PropTypes.func,
};

export const RoleForm = reduxForm({
  form: 'roleForm',
  enableReinitialize: true,
  destroyOnUnmount: false,
})(RoleFormComponent);
